import { gql } from '../../../../../hooks'

export const DELETE_PROCEDURES = gql`
  mutation AdministrationDeleteSamplingProcedures($id: ID!) {
    aDelete(path: "sampling/procedures", id: $id) {
    }
  }
`

export const LIST_PROCEDURES = gql`
  query AdministrationListSamplingProcedures(
    $page: Int
    $limit: Int
    $filter: JSONObject
  ) {
    aList(
      path: "sampling/procedures"
      filter: $filter
      page: $page
      limit: $limit
    ) {
      pagination {
        page
        limit
        number_of_pages
      }
    }
  }
`
